<template>
  <div class="page">
    <van-sticky :offset-top="0">
      <van-nav-bar :title="title" left-arrow @click-left="onClickLeft">
      </van-nav-bar>
    </van-sticky>
    <van-cell title="客户信息">
      <template #right-icon>
        <van-button type="info" size="small" @click="editDetailInfo"
          >编辑</van-button
        >
      </template>
    </van-cell>
    <BaseInfo :formdate="detailInfo" :isUser="isUser"></BaseInfo>
    <van-tabs
      class="tabs"
      v-model="currentTab"
      line-height="1px"
      line-width="4em"
      title-inactive-color="#41444E"
      title-active-color="#3C86FF"
    >
      <van-tab title="跟进记录" name="follow">
        <FollowItem
          v-for="item in followList"
          :item="item"
          :detailInfo="detailInfo"
          :isUser="isUser"
          :key="item.id"
        ></FollowItem>
        <van-empty description="暂无跟进" v-if="!followList.length"/>
      </van-tab>
      <van-tab title="联系人" name="contact" v-if="isUser">
        <RelationtItem
          v-for="item in contactsList"
          :item="item"
          :key="item.id"
        ></RelationtItem>
        <van-empty description="暂无联系人" v-if="!contactsList.length"/>
      </van-tab>
    </van-tabs>
    <div class="bottom-btn">
      <div class="btns">
        <van-button
          round
          block
          type="info"
          @click="follow()"
          native-type="submit"
          >新增跟进</van-button
        >
        <van-button
          round
          block
          type="info"
          @click="updateCustomerStatus"
          v-if="isUser"
          native-type="submit"
          >更改成交状态</van-button
        >
        <van-button
          round
          block
          type="info"
          @click="clueTurnIntoCustomers"
          v-else
          native-type="submit"
          >转换为客户</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Api from "@/api/user";
import { Toast, sticky, Dialog, Empty } from "vant";
import qs from "qs";
Vue.use(sticky);
Vue.use(Empty);
export default {
  components: {
    BaseInfo: () => import("./components/BaseInfo"),
    FollowItem: () => import("./components/FollowItem"),
    RelationtItem: () => import("@/views/Relation/RelationtItem"),
  },
  data() {
    return {
      homeNo: this.$route.params.homeNo,
      showCancel: false,
      currentTab: this.$route.query.currentTab || "follow",
      form: {
        approvalReason: "",
      },
      detailInfo: {},
      applyInfo: null,
      attachmentFiles: null, //档案资料
      incomingFiles: null, //进件资料
      followList: [], //跟进记录
      contactsList: [], //联系人
    };
  },
  computed: {
    isUser() {
      return this.$route.query.type == "user";
    },
    title() {
      return this.isUser ? "客户详情" : "线索详情";
    },
    id() {
      return this.$route.params.id;
    },
  },
  watch: {
    currentTab: {
      immediate: true,
      handler(val) {
        const targetUrl = this.$router.resolve({
          name: this.$route.name,
          params: this.$route.param,
          query: {
            ...this.$route.query,
            currentTab: val,
          },
        }).href;
        if (val == "follow") {
          this.getFollowList();
        } else {
          this.getContactsList();
        }
        history.replaceState(null, "", targetUrl);
      },
    },
  },
  methods: {
    // 加载详情
    async loadDetail() {
      const loading = Toast.loading();
      try {
        const res = await Api.findDetailById({
          id: this.id,
          isUser: this.isUser,
        });
        this.detailInfo = res.data;
        loading.close();
      } catch (error) {
        Toast.fail(error);
      }
    },
    getFollowList() {
      Api.getFollowList({
        pageNo: 1,
        pageSize: 20,
        bizType: this.isUser ? 2 : 1,
        bizId: this.id,
      }).then((res) => {
        this.followList = res?.data?.list || [];
      });
    },
    getContactsList() {
      Api.getContactsList({
        pageNo: 1,
        pageSize: 20,
        customerId: this.id,
      }).then((res) => {
        this.contactsList = res?.data?.list || [];
      });
    },
    editDetailInfo() {
      this.$router.push({
        path: "/list/create",
        query: {
          id: this.id,
          type: this.$route.query.type,
        },
      });
    },
    follow() {
      if (this.isUser) {
        this.$router.push(
          `/follow?bizId=${this.id}&type=user&name=${this.detailInfo.name}`
        );
      } else {
        this.$router.push(
          `/follow?bizId=${this.id}&name=${this.detailInfo.name}`
        );
      }
    },
    clueTurnIntoCustomers() {
      Dialog.confirm({
        title: "提示",
        message: `确定将【${this.detailInfo.name}】转化为客户吗？`,
      })
        .then(async () => {
          await Api.clueTurnIntoCustomers(this.detailInfo.id);
          Toast.success("转化成功");
          this.$router.go(-1);
        })
        .catch((res) => {
          console.log("res :>> ", res);
        });
    },
    updateCustomerStatus() {
      Dialog.confirm({
        title: "提示",
        message: `确定更新成交状态为【${
          this.detailInfo.dealStatus ? "未成交" : "已成交"
        }】吗？`,
      })
        .then(async () => {
          let url = qs.stringify({
            id: this.detailInfo.id,
            dealStatus: !this.detailInfo.dealStatus,
          });
          await Api.updateCustomerStatus(url);
          Toast.success("更新成交状态成功");
        })
        .catch((res) => {
          console.log("res :>> ", res);
        });
    },
  },
  mounted() {
    this.loadDetail();
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/variables.less";
.page {
  height: 100%;
  overflow-y: auto;

  .actions {
    display: flex;
    flex-direction: row;
    background: #ffffff;
    padding: 13px 13px;
    .van-button {
      border-radius: 3px;
      margin-right: 8px;
      height: 36px;
      line-height: 36px;
      &:last-child {
        margin-right: 0;
      }
    }
    .flex1 {
      flex: 1;
    }
  }
}
.tabs {
  /deep/ .van-tabs__content {
    flex: 1;
    .van-tab__pane {
      background: @pageBg;
    }
  }

  /deep/ .van-tabs__nav--line {
    justify-content: flex-start;
    padding-bottom: 10px;
    .van-tab {
      flex: 0 0 30%;
    }
  }
  /deep/ .van-tabs__line {
    background: #3c86ff;
  }
}

.dialog-form {
  padding: 10px 10px;
  .title {
    text-align: center;
    font-size: 15px;
    margin: 10px 0px;
  }
  .van-field {
    margin: 5px 0px 10px 0px;
    border: 1px solid rgba(119, 119, 119, 0.5);
    border-radius: 5px;
  }
}
</style>
